import { useId } from "react";
import { COLORS } from "assets/styles/colors";
import { ErrorMessage } from "common";

import * as S from "./styled";

export const PrimaryTextarea = ({ placeholder, register, error, id, ...rest }) => {
  const generatedId = useId();
  const inputId = id || register?.name || generatedId;

  return (
    <S.TextareaWrapper className="w-100 primary-100 my-2 relative">
      <S.Area
        className="!outline-transparent"
        color="green"
        error={!!error}
        id={inputId}
        label={placeholder}
        labelProps={{
          htmlFor: inputId,
          style: { fontFamily: "Montserrat", color: COLORS.dimgrey },
          className: "peer-placeholder-shown:text-base",
        }}
        {...register}
        {...rest}
        variant="standard"
      />

      {error ? <ErrorMessage>{error?.message}</ErrorMessage> : null}
    </S.TextareaWrapper>
  );
};
